import React, { useState } from "react";
import "../../../styles/payrole-system/payrole-mobile.css";
import {
  convertThenFormat1,
  formatDateTime,
  getMonthYear,
} from "../../common-data/Converts";
import { renderActionButton } from "../PayroleMocks";
import PaginationBar from "../../lead-management/lms-v2/lms-customised-comps/PaginationBar";

const PayroleTableMobile = ({
  tableData,
  tablePagination,
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  handleModalClick,
  isStaff,
  isDraft,
}) => {
  const [expandedCards, setExpandedCards] = useState(new Set());

  const toggleCardExpansion = (index) => {
    setExpandedCards((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(index)) {
        newSet.delete(index);
      } else {
        newSet.add(index);
      }
      return newSet;
    });
  };

  if (!tableData || tableData.length === 0) {
    return (
      <div className="pp-mob-container">
        <div className="pp-mob-no-data">No payroll data available</div>
      </div>
    );
  }

  return (
    <div className="pp-mob-container">
      {tableData.map((row, index) => {
        const isExpanded = expandedCards.has(index);
        const approvalRequestSent = row?.approval_request_send;

        return (
          <div key={row.uid || index} className="pp-mob-card">
            <div className="pp-mob-card-header">
              <div className="pp-mob-month-employee">
                <div className="pp-mob-month">
                  {row?.date ? getMonthYear(row.date) : "-"}
                </div>
                <div className="pp-mob-employee-info">
                  <span className="pp-mob-employee-name">
                    {row?.name || "NA"}
                  </span>
                  <span className="pp-mob-employee-role">
                    ({row?.account_type?.replace(/_/g, " ") || "NA"})
                  </span>
                </div>
              </div>
            </div>

            <div className="pp-mob-status-section">
              <div className="pp-mob-status-item">
                <span className="pp-mob-status-label">User Status:</span>
                <span
                  className={`pp-mob-badge ${
                    row?.user_approval === "approved"
                      ? "pp-mob-green-badge"
                      : row?.user_approval === "pending"
                      ? "pp-mob-yellow-badge"
                      : "pp-mob-red-badge"
                  }`}
                >
                  {row?.user_approval === "pending"
                    ? "Pending Review"
                    : row?.user_approval || "NA"}
                </span>
              </div>

              {!isStaff && (
                <div className="pp-mob-status-item">
                  <span className="pp-mob-status-label">HR Approval:</span>
                  <span
                    className={`pp-mob-badge ${
                      row?.stack_holder_approval === "approved"
                        ? "pp-mob-green-badge"
                        : row?.user_approval === "pending" ||
                          row?.stack_holder_approval === "pending"
                        ? "pp-mob-yellow-badge"
                        : "pp-mob-red-badge"
                    }`}
                  >
                    {row?.user_approval === "pending"
                      ? "Review Required"
                      : row?.stack_holder_approval || "NA"}
                  </span>
                </div>
              )}

              {isStaff && (
                <div className="pp-mob-status-item">
                  <span className="pp-mob-status-label">HR Approval:</span>
                  <span
                    className={`pp-mob-badge ${
                      row?.stack_holder_approval === "approved"
                        ? "pp-mob-green-badge"
                        : row?.user_approval === "pending" ||
                          row?.stack_holder_approval === "pending"
                        ? "pp-mob-yellow-badge"
                        : "pp-mob-red-badge"
                    }`}
                  >
                    {row?.user_approval === "pending"
                      ? "Review Required"
                      : row?.stack_holder_approval || "NA"}
                  </span>
                </div>
              )}
            </div>

            <div className="pp-mob-actions-section">
              {renderActionButton(row, isStaff, handleModalClick)}
              {isDraft && (
                <button
                  key="send-email"
                  type="button"
                  className={`pp-employee-payroll-action-button ${
                    approvalRequestSent
                      ? "pp-transparent-badge text-green"
                      : "pp-blue-badge"
                  }`}
                  style={{ justifyContent: "flex-start" }}
                  onClick={() => handleModalClick(row, "send_email")}
                >
                  {approvalRequestSent ? "Email Sent" : "Send Email"}
                </button>
              )}
            </div>

            <div className="pp-mob-expand-section">
              <button
                className="pp-mob-expand-btn"
                onClick={() => toggleCardExpansion(index)}
              >
                <span>Click to see all info</span>
                <span
                  className={`pp-mob-expand-icon ${
                    isExpanded ? "pp-mob-expanded" : ""
                  }`}
                >
                  ▼
                </span>
              </button>

              {isExpanded && (
                <div className="pp-mob-details">
                  {!isStaff && (
                    <div className="pp-mob-detail-item flex-col">
                      <span className="pp-mob-detail-label">Gym Name:</span>
                      <span className="pp-mob-detail-value">
                        {row?.gym_name || "NA"}
                      </span>
                    </div>
                  )}

                  <div className="pp-mob-detail-item">
                    <span className="pp-mob-detail-label">Attendance:</span>
                    <div className="pp-mob-attendance">
                      <span className="pp-mob-present">
                        {row?.total_present || 0} Present
                      </span>
                      <span className="pp-mob-absent">
                        {row?.total_absent || 0} Absent
                      </span>
                    </div>
                  </div>

                  <div className="pp-mob-detail-item">
                    <span className="pp-mob-detail-label">Monthly Salary:</span>
                    <span className="pp-mob-detail-value">
                      ₹{convertThenFormat1(row?.monthly_salary)}
                    </span>
                  </div>

                  <div className="pp-mob-detail-item">
                    <span className="pp-mob-detail-label">Gross Salary:</span>
                    <span className="pp-mob-detail-value">
                      ₹{convertThenFormat1(row?.total_basic_salary)}
                    </span>
                  </div>

                  <div className="pp-mob-detail-item">
                    <span className="pp-mob-detail-label">Deductions:</span>
                    <span className="pp-mob-detail-value pp-mob-deduction">
                      -₹{convertThenFormat1(row?.deduction)}
                    </span>
                  </div>

                  <div className="pp-mob-detail-item">
                    <span className="pp-mob-detail-label">Net Salary:</span>
                    <span className="pp-mob-detail-value pp-mob-net-salary">
                      ₹{convertThenFormat1(row?.net_salary)}
                    </span>
                  </div>

                  <div className="pp-mob-detail-item">
                    <span className="pp-mob-detail-label">Incentive:</span>
                    <span className="pp-mob-detail-value">
                      ₹{convertThenFormat1(row?.incentive)}
                    </span>
                  </div>

                  <div className="pp-mob-detail-item">
                    <span className="pp-mob-detail-label">ESI Amount:</span>
                    <span className="pp-mob-detail-value">
                      ₹{convertThenFormat1(row?.esi_amount)}
                    </span>
                  </div>

                  <div className="pp-mob-detail-item">
                    <span className="pp-mob-detail-label">PF Amount:</span>
                    <span className="pp-mob-detail-value">
                      ₹{convertThenFormat1(row?.pf_amount)}
                    </span>
                  </div>

                  <div className="pp-mob-detail-item">
                    <span className="pp-mob-detail-label">Date Added:</span>
                    <span className="pp-mob-detail-value">
                      {row?.date_added ? formatDateTime(row.date_added) : "-"}
                    </span>
                  </div>
                </div>
              )}
            </div>
          </div>
        );
      })}

      <PaginationBar
        isPage={isPage}
        setIsPage={setIsPage}
        paginationArray={tablePagination}
        pageLimit={pageLimit}
        setPageLimit={setPageLimit}
      />
    </div>
  );
};

export default PayroleTableMobile;
